import { render } from "./LoginItem.vue?vue&type=template&id=a815400e&scoped=true"
import script from "./LoginItem.vue?vue&type=script&lang=js"
export * from "./LoginItem.vue?vue&type=script&lang=js"

import "./LoginItem.vue?vue&type=style&index=0&id=a815400e&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a815400e"]])

export default __exports__